import React, { useEffect, useState } from "react";

import {
  Stack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Spinner,
  IconButton,
  useDisclosure,
  Tooltip,
  Button,
} from "@chakra-ui/react";

import TablePagination from "components/TablePagination/TablePagination";

import { GetUserAssociatedSupplierForAdmin } from "services/SuppliersService";

import data_not_found_blue_icon from "assets/images/icons/general_icons/data_not_found_blue_icon.png";
import AssociateNewSupplierModal from "./components/AssociateNewSupplier/AssociateNewSupplierModal";

const sort_last_updated_selector_data = [
  {
    value: "ASC",
    label: "Oldest First",
  },
  { value: "DSC", label: "Newest First" },
];

export default function AssociatedSuppliersTab(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  // use states
  const [supplierDetails, setSuppliersDetails] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [updateTable, setUpdateTable] = useState(false);

  const {
    isOpen: isOpenAssociateSupplierModal,
    onOpen: onOpenAssociateSupplierModal,
    onClose: onCloseAssociateSupplierModal,
  } = useDisclosure();

  useEffect(() => {
    const getSuppliers = async () => {
      setIsLoading(true);

      const params = {
        page_size: pageSize,
        page_number: currentPage,
        user_id: props.user_id,
      };

      const response_suppliers_data = await GetUserAssociatedSupplierForAdmin(
        params
      );

      setTotalPages(response_suppliers_data.data.pages);
      setTotalRecords(response_suppliers_data.data.total_records);

      setSuppliersDetails(response_suppliers_data?.data.data);

      setIsLoading(false);
    };

    getSuppliers();
  }, [currentPage, pageSize, updateTable]);

  console.log("supplier ", supplierDetails);

  return (
    <div className="">
      <div className="flex flex-col  ">
        {isLoading && (
          <div className="flex flex-row justify-center   h-[34rem] ">
            <Spinner className="my-auto" size="xl" />
          </div>
        )}

        {!isLoading && (
          <AssociateNewSupplierModal
            isOpen={isOpenAssociateSupplierModal}
            onClose={onCloseAssociateSupplierModal}
            user_id={props.user_id}
            already_associated_supplier_list={supplierDetails}
            updateTable={() => setUpdateTable(!updateTable)}
          />
        )}

        <div className="overflow-x-auto   max-h-[34rem]  overflow-y-auto  ">
          {!isLoading && (
            <>
              <div className="w-full flex flex-row justify-end">
                <div className="pb-3">
                  <Button onClick={onOpenAssociateSupplierModal}>
                    Associate Supplier
                  </Button>
                </div>
              </div>

              <table className=" w-full  border border-[#e9e9e9] table-auto">
                <thead>
                  <tr className="bg-[#e9e9e9] h-[2.63rem]">
                    <th className="pl-4 py-1.5  ">
                      <p className="table-heading">Name</p>
                    </th>
                    <th className="py-1.5 table-heading  max-w-60 xl:max-w-xl">
                      URL
                    </th>
                    <th className="py-1.5 table-heading">Category</th>
                  </tr>
                </thead>
                <tbody className=" ">
                  {supplierDetails?.map((data, index) => {
                    data = data.supplier;
                    return (
                      <tr
                        className="border-x primary-border-color hover:bg-gray-100 hover:cursor-pointer group h-[3.13rem] "
                        key={index}
                      >
                        <td className="pl-2 py-2.5 max-w-xs truncate   group-hover:underline h-full ">
                          <Tooltip label={data.supplier_name}>
                            <p className="table-text">{data.supplier_name}</p>
                          </Tooltip>
                        </td>
                        <td className="table-text-light truncate  max-w-60 xl:max-w-xl">
                          <Tooltip label={data.supplier_url}>
                            {data.supplier_url}
                          </Tooltip>
                        </td>
                        <td className="text-center ">{data.supplier_class}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>
        {!supplierDetails?.length && !isLoading && (
          <div className="flex flex-row justify-center h-[32rem]    ">
            <div className="my-auto flex flex-row justify-center gap-2 ">
              <img src={data_not_found_blue_icon} />
              <p>Data Not Found</p>
            </div>
          </div>
        )}
        <TablePagination
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalRecords={totalRecords}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
}
